"use client"

import { Ship } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShipIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShipIcon = component(Icon)({ as: Ship })
